import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const systemConfigurationRoute: InvariantJiraRoute = {
	name: 'system-configuration-general',
	path: '/jira/settings/system/general-configuration',
	exact: true,
};
